import { has } from 'lodash';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { InfiniteScroll, LeisureItem, ProductsContext, Skeleton } from 'components';
import { appService } from 'services';

const LeisureItemSkeletons = () => {
  return (
    <>
      {[...Array(6)].map((_, index) => (
        <div
          className="product-item leisure"
          data-test-id="leisureProductSkeleton"
          key={`leisure-product-skeleton-${index}`}
        >
          <div className="image-container">
            <Skeleton
              type="square"
              size="xl"
              classNames="h-full w-full lg:h-[14.38rem] lg:rounded-tl-xl lg:rounded-tr-xl lg:rounded-b-none"
            />
          </div>

          <div className="content-container">
            <div>
              <Skeleton type="text" size="xs" classNames="w-full xl:w-full lg:h-8" />
              <Skeleton type="text" size="xs" classNames="w-full xl:w-full lg:h-8" />
            </div>
            <Skeleton classNames="w-full h-24 xl:w-1/5 lg:h-8" />
            <Skeleton size="xs" classNames="w-full xl:w-1/5 lg:h-8" />
          </div>
        </div>
      ))}
    </>
  );
};

const LeisuresList = () => {
  const { t } = useTranslation();
  const { page, setPage, itemsPerPage, productsLeisures: products, loadingLeisures } = useContext(ProductsContext);
  const showEmptySearch = !loadingLeisures && has(products, 'total') && products.total === 0;
  const hasFetchedAll = products?.leisures?.length && products?.total === products?.leisures?.length;

  const loadNextLeisures = () => {
    if (loadingLeisures) return;

    // Check if there are more leisures to fetch
    if (products?.total > page * itemsPerPage.leisures) {
      setPage((prev) => prev + 1);
    }

    // Return leisures items for InfiniteScroll component
    return products?.leisures || [];
  };

  return (
    <div data-test-id="leisuresList">
      <div className="pb-6 lg:pb-4 lg:mb-6 lg:border-b lg:border-gray-200">
        {loadingLeisures ? (
          <Skeleton classNames="h-8 w-24" />
        ) : (
          <span data-test-id="leisuresCount">{t('totalResultsLeisure', { count: products?.total ?? 0 })}</span>
        )}
      </div>

      <InfiniteScroll
        items={products?.leisures || []}
        loadMore={loadNextLeisures}
        className="leisure-products-container"
        options={{
          displayItem: (item, index) => <LeisureItem leisure={item} key={`leisure-product-${index}`} />,
          endMessage: '',
          loader: showEmptySearch || hasFetchedAll ? <></> : <LeisureItemSkeletons />
        }}
      />

      <div className="leisure-products-container">
        {showEmptySearch && (
          <div className="col-span-12 flex-center-center flex-col gap-12">
            <img src={appService.loadBrandImage('emptyResults')} alt="" width="400" height="250" />

            <p className="uppercase font-semibold flex-center-center flex-col">
              <span className="block">{t('notFound.content')}</span>
              {t('notFound.helpLeisures')}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeisuresList;
